import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { DialogTitle, DialogActions, Button, Avatar, Icon } from "@material-ui/core";
import { Backbone } from "js/vendor";
import log from "js/core/logger";
import { Divider, WhiteIconButton } from "js/react/components/UiComponents";
import { FlexSpacer, Gap10, Gap5 } from "js/react/components/Gap";
import { app } from "js/namespaces";
import { UIController } from "js/editor/dialogs/UIController";
import { BeautifulDialog, DialogContent, ShowDialogAsync } from "js/react/components/Dialogs/BaseDialog";
import { ShareDialog } from "js/react/views/PresentationSettings/dialogs/ShareDialog";
import { ds } from "js/core/models/dataService";
import { AssignCollaboratorOrTeammateDropdown } from "js/editor/components/AssignCollaboratorOrTeammateDropdown";
import permissionDS from "js/react/views/PresentationSettings/dataservices/PermissionsDataService";
import { HelpButton } from "./components/helpButton";
import { handleEditSharedSlide } from "js/editor/editShareSlide";
import { ShowConfirmationDialog } from "js/react/components/Dialogs/BaseDialog";
import { trackActivity } from "js/core/utilities/utilities";
import NotificationsService from "js/core/services/notifications";

const Bar = styled.div`
  background: #333;
  width: 60px;
  top: 50px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
`;

const Collaborators = styled.div`
  margin-top: 10px;
  .user {
    opacity: 0.5;
    margin: 5px;
  }
  .user.active {
    opacity: 1;
  } 
  &:empty{
    display:none;
  }
`;

const CommentsCountLabelContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        font-size: 10px;
        color: #000000;
        margin-bottom: 3px;
    }
`;

const UnreadCommentsRedDot = styled.span`
    width: 6px;
    height: 6px;
    background-color: #ff0000;
    border-radius: 50%;
    border: 1px solid #333333;
    position: absolute;
    left: 11px;
    top: 11px;
`;

const WhiteIconButtonWithLabel = styled(WhiteIconButton)`
    :hover label {
        opacity: 1;
    }
`;

const WhiteIconButtonLabel = styled.label`
    font-size: 9px;
    text-align: center;
    text-transform: uppercase;
    color: #ccc;
    transition: opacity 350ms;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    bottom: 0px;
    letter-spacing: 0.75px;
    font-family: "Source Sans Pro", sans-serif;
`;

export class InviteEditCollaboratorDialog extends Component {
    state = {
        fetching: false
    }

    handleInviteCollaborator = () => {
        const { user, closeDialog, old_value } = this.props;

        this.setState({ fetching: true });

        const emails = [user.email];
        const permissions = { emails, permission: "write", customMessage: "" };
        permissionDS.createPermission(permissions, ds.selection.presentation.id, false)
            .then(() => closeDialog(true))
            .catch(err => log.error(err));
        const props = {
            old_value: old_value || null,
            new_value: "write",
            recipient_emails: emails,
            sender_email: app.user.getEmail(),
            location: "assign"
        };
        trackActivity("Collab", "Invite", null, null, props, { audit: true });
    };

    render() {
        const { message, title, closeDialog } = this.props;
        const { fetching } = this.state;

        return (
            <BeautifulDialog onClose={() => closeDialog(false)}>
                <DialogTitle style={{ display: "flex", width: "100%" }} disableTypography={true}>
                    <h2>{title}</h2>
                </DialogTitle>
                <DialogContent>
                    <p>{message}</p>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "space-between" }}>
                    <Button disabled={fetching} onClick={() => closeDialog(false)}>Nevermind</Button>
                    <Button disabled={fetching} onClick={this.handleInviteCollaborator} color="primary">Invite Collaborator</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export const CollaborationBarContainer = Backbone.View.extend({
    className: "collaboration-bar",

    showComments: true,
    showAssignUser: true,
    showCollaboration: true,

    render: function() {
        ReactDOM.render(<CollaborationBar showComments={this.showComments} showAssignUser={this.showAssignUser} showCollaboration={this.showCollaboration} />, this.el);
        return this;
    },

    onShowSlideGrid: function() {
        this.showComments = false;
        this.showAssignUser = false;
        this.showCollaboration = false;

        this.render();
    },

    onHideSlideGrid: function() {
        this.showComments = true;
        this.showAssignUser = true;
        this.showCollaboration = true;

        this.render();
    }
});

class CollaborationBar extends Component {
    state = {
        search: "",
        assignedUser: null,
        anchorEl: null,
        collaborators: [],
        teammates: [],
        comments: [],
        isShowingDialog: false
    };

    constructor() {
        super();

        this.user = app.user.getAuthUser();
        this.assignUserToSlideDropdownAnchorRef = React.createRef();
    }

    componentDidMount() {
        const { collaboratorsAndTeammates$, assignedToSlideUser$, slideComments$ } = ds.getObservables();
        this.collaboratorsAndTeammatesSubscription = collaboratorsAndTeammates$.subscribe(this.handleCollaboratorsAndTeammatesUpdate);
        this.assignedToSlideUserSubscription = assignedToSlideUser$.subscribe(this.handleAssignedUserUpdate);
        this.commentsSubscription = slideComments$.subscribe(this.handleCommentsUpdate);
    }

    componentWillUnmount() {
        if (this.collaboratorsAndTeammatesSubscription) {
            this.collaboratorsAndTeammatesSubscription.unsubscribe();
        }

        if (this.assignedToSlideUserSubscription) {
            this.assignedToSlideUserSubscription.unsubscribe();
        }

        if (this.commentsSubscription) {
            this.commentsSubscription.unsubscribe();
        }
    }

    showDialog(...args) {
        this.setState({ isShowingDialog: true });

        return ShowDialogAsync(...args)
            .then(dialogResult => {
                this.setState({ isShowingDialog: false });
                return dialogResult;
            });
    }

    closeCollaboratorDropdown = () => {
        this.setState({ anchorEl: null, search: "" });
    }

    handleCollaboratorsAndTeammatesUpdate = ({ collaborators, teammates }) => {
        this.setState({ collaborators, teammates });
    }

    handleAssignedUserUpdate = assignedUser => {
        this.setState({ assignedUser });
    }

    handleCommentsUpdate = comments => {
        this.setState({ comments });
    }

    handleToggleHelp = () => {
        UIController.toggleHelpPanel(false);
    }

    handleShowComments = () => {
        app.mainView.editorView.toggleComments();
    }

    handleAddCollaborator = () => {
        this.showDialog(ShareDialog, {
            emails: [this.state.search],
            presentation: ds.selection.presentation,
            selectedPanel: "collaborate",
            location: "assign"
        });
    }

    assignUserToSlide = user => {
        const slide = ds.selection.slide;

        const assignUser = () => {
            if (user.isPending && slide.get("assignedPendingUser") !== user.email) {
                slide.update({ assignedUser: null, assignedPendingUser: user.email, pendingUserAssignedBy: app.user.id });
                if (slide.isLibrarySlide()) {
                    app.mainView.editorView.handleSaveSharedSlide();
                }
            } else if (slide.get("assignedUser") !== user.uid) {
                slide.update({ assignedUser: user.uid, assignedPendingUser: null, pendingUserAssignedBy: null });
                if (slide.isLibrarySlide()) {
                    app.mainView.editorView.handleSaveSharedSlide();
                }
                // Notifying the assignee
                NotificationsService.notifyOnUserAssignedToSlide(user.uid, ds.selection.presentation.id, slide.id)
                    .catch(err => log.error(err));
            }
            const props = {
                slide_id: slide.id,
                email: user.email,
                user_id: user.uid || null
            };
            trackActivity("Collab", "Assign", null, null, props, { audit: true });
        };

        if (slide.isLibrarySlide()) {
            ShowConfirmationDialog({
                title: "Assigning user will save this Team Slide, are you sure?",
                message: "Changes will be applied to all presentations that use this slide.",
                cancelButtonLabel: "Cancel",
                acceptCallback: assignUser,
                cancelCallback: () => { }
            });
        } else {
            assignUser();
        }
    }

    handleAssignCollaborator = user => {
        if (user.permissionType === "view") {
            this.showDialog(InviteEditCollaboratorDialog, {
                title: `Would you like to give ${user.displayName || user.email} edit permission?`,
                message: `This collaborator currently has view only access. Only collaborators with edit permission can be assigned a slide.`,
                user,
                old_value: user.permissionType
            }).then(wasInvited => {
                if (wasInvited) {
                    this.assignUserToSlide(user);
                    this.closeCollaboratorDropdown();
                }
            });
        } else {
            this.assignUserToSlide(user);
            this.closeCollaboratorDropdown();
        }
    }

    handleAssignTeammate = user => {
        this.showDialog(InviteEditCollaboratorDialog, {
            title: `Would you like to invite ${user.displayName || user.email} to collaborate on and edit this presentation?`,
            message: `Only collaborators with edit permission can be assigned a slide.`,
            user
        }).then(wasInvited => {
            if (wasInvited) {
                this.assignUserToSlide(user);
                this.closeCollaboratorDropdown();
            }
        });
    }

    handleUnassignUser = () => {
        ds.selection.slide.update({ assignedUser: null, assignedPendingUser: null });
    }

    handleSearchInputChange = event => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ search: event.target.value });
    }

    handleClickAssignButton = event => {
        if (app.mainView.editorView.checkIfSharedSlideIsReadOnly()) {
            handleEditSharedSlide();
            return;
        }
        this.setState({ anchorEl: event.currentTarget });
    }

    render() {
        const { showComments, showAssignUser, showCollaboration } = this.props;
        const { comments, search, collaborators, teammates, anchorEl, assignedUser, isShowingDialog } = this.state;

        const hasUnreadComments = comments.some(comment => comment.authorUid !== this.user.uid && (!comment.readBy || !comment.readBy[this.user.uid]));

        return (
            <Bar>
                {(showComments || showAssignUser) && <Gap10 />}
                {showComments &&
                    <>
                        <WhiteIconButtonWithLabel onClick={this.handleShowComments}>
                            <Icon>mode_comments</Icon>
                            {comments.length > 0 &&
                                <CommentsCountLabelContainer>
                                    <span>
                                        {comments.length}
                                    </span>
                                </CommentsCountLabelContainer>
                            }
                            {hasUnreadComments && <UnreadCommentsRedDot />}
                            <WhiteIconButtonLabel>Comments</WhiteIconButtonLabel>
                        </WhiteIconButtonWithLabel>
                        <Gap5 />
                        <Divider color="#555" margin={0} />
                    </>
                }
                {showAssignUser &&
                    <>
                        <WhiteIconButtonWithLabel ref={this.assignUserToSlideDropdownAnchorRef} onClick={this.handleClickAssignButton}>
                            {assignedUser
                                ? <Avatar title={assignedUser.displayName || assignedUser.email} src={assignedUser.photoURL} />
                                : <Icon>person_pin</Icon>
                            }
                            <WhiteIconButtonLabel>Owner</WhiteIconButtonLabel>
                        </WhiteIconButtonWithLabel>
                        <AssignCollaboratorOrTeammateDropdown
                            showAssignUserInput={true}
                            anchorEl={anchorEl}
                            maxUsersToShow={6}
                            search={search}
                            collaborators={collaborators}
                            teammates={teammates}
                            onClose={() => {
                                if (!isShowingDialog) this.closeCollaboratorDropdown();
                            }}
                            onCollaboratorClick={this.handleAssignCollaborator}
                            onTeammateClick={this.handleAssignTeammate}
                            onAddCollaboratorClick={this.handleAddCollaborator}
                            assignedUser={assignedUser}
                            onUnassignClick={this.handleUnassignUser}
                            onSearchInputChange={this.handleSearchInputChange}
                            anchorRef={this.assignUserToSlideDropdownAnchorRef}
                        />
                        <Gap5 />
                        <Divider color="#555" margin={0} />
                    </>
                }
                {showCollaboration &&
                    <>
                        <Collaborators className="collaborators-pane">
                        </Collaborators>
                        <Gap10 />
                        <WhiteIconButtonWithLabel className="add-collaborators" onClick={this.handleAddCollaborator}>
                            <Icon>person_add_alt_1</Icon>
                            <WhiteIconButtonLabel>Invite</WhiteIconButtonLabel>
                        </WhiteIconButtonWithLabel>
                    </>
                }
                <FlexSpacer />
                <HelpButton />
            </Bar>
        );
    }
}
